import { useQuery } from '@tanstack/vue-query'
import QueryKeys from '@/vue-query/QueryKeys'
import { useFrontEndDataApi } from '@/composables/api/useFrontEndDataApi'

export function useFrontEndDataQuery() {
   const client = useFrontEndDataApi()

   return useQuery([QueryKeys.FrontEnd], () => client.get(), { staleTime: Infinity,  refetchOnWindowFocus: false, cacheTime: Infinity})
}
